import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetGgr = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_GGR
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetGgrAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetGgr as SetGetGgr
}